import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth.service';
import { OrganizationService } from '../organization.service';
import { RedirectService } from '../redirect.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {
  collapsed = true;
  oldLoggedIn = false;
  navItems: object[];
  showParentBanner: boolean = true;
  isParent: boolean = this.authService.isParent();
  environment = environment;

  constructor(
    public authService: AuthService,
    public organizationService: OrganizationService,
    public redirectService: RedirectService,
    private router: Router,
    private location: Location
  ) { }

  ngOnInit() {
    this.getNavItems();
  }

  getHomeUrl(): string {
    if (this.isParent) {
      return this.getAccountUrl();
    }
    return "/";
  }

  getAccountUrl(): string {
    if (this.isParent) {
      let userId = this.authService.session.ID;
      return `/parent/account/${userId}`;
    }
    return "/my-account";
  }

  getNavItems(): void {

    this.navItems = [];
    if (this.authService.isLoggedIn()) {
      if (this.organizationService.rootOrgId) {
        this.location.path().includes('parent') ? this.showParentBanner = true : this.showParentBanner = false;
        this.navItems.push({
          title: this.organizationService.orgs[0].Description,
          routerLink: this.redirectService.getRedirectUrl(),
        });
      } 
      if (!this.location.path().includes('parent')) {
        this.showParentBanner = false;
        this.navItems.push({
          title: 'Organizations',
          routerLink: this.redirectService.getRedirectUrl(),
        });
      }
      if (this.authService.isLoggedIn()) {
        this.navItems.push({
          title: 'Accounts',
          routerLink: '/accounts',
        });
      }
      if (this.authService.isInternal()) {
        this.navItems.push({
          title: 'Students',
          routerLink: '/students',
        });
        this.navItems.push({
          title: 'License Tracking',
          routerLink: '/license-tracking',
        });
      }
    }
    else {
      this.showParentBanner = false;
      this.navItems.push({
        title: 'Log in',
        routerLink: '/login',
      });
    };
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
